export default "__VITE_PUBLIC_ASSET__5603d7ad__"